import { Card, Typography } from "antd";
import { Fragment } from "react";
import { Navigate, useParams } from "react-router-dom";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

import "./transaction.css";

import dayjs from "dayjs";
import {
  transactionApi,
  useGetTransactionQuery,
} from "../../redux/rtk/features/transaction/transactionApi";
import CommonDelete from "../CommonUi/CommonDelete";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

//PopUp

const DetailTransaction = () => {
  const { id } = useParams();

  const { data: payment } = useGetTransactionQuery(id);

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  return (
    <div>
      <PageTitle title=' Back ' subtitle={`Payment ${id} information`} />

      <UserPrivateComponent permission={"readSingle-transaction"}>
        <div className='mr-top'>
          {payment ? (
            <Fragment key={payment.id}>
              <Card bordered={false} className='card-custom'>
                <div
                  className='card-header d-flex justify-content-between mb-2'
                  style={{ padding: 0 }}
                >
                  <h5>
                    <i className='bi bi-person-lines-fill'></i>
                    <span className='mr-left'>
                      ID : {payment.id} | {payment.date}
                    </span>
                  </h5>
                  <div className='text-end'>
                    <CommonDelete
                      permission={"delete-transaction"}
                      deleteThunk={
                        transactionApi.endpoints.deleteTransaction.initiate
                      }
                      navigatePath={"/admin/transaction/"}
                      id={id}
                    />
                  </div>
                </div>
                <div>
                  <p>
                    <Typography.Text className='font-semibold'>
                      Date :
                    </Typography.Text>{" "}
                    {dayjs(payment.date).format("YYYY-MM-DD")}
                  </p>

                  <p>
                    <Typography.Text strong>Amount :</Typography.Text>{" "}
                    {payment.amount}
                  </p>

                  <p>
                    <Typography.Text strong>Particulars :</Typography.Text>{" "}
                    {payment.particulars}
                  </p>
                  <p>
                    <Typography.Text strong>Type :</Typography.Text>{" "}
                    {payment.type}
                  </p>
                </div>
              </Card>
            </Fragment>
          ) : (
            <Loader />
          )}
        </div>
      </UserPrivateComponent>
    </div>
  );
};

export default DetailTransaction;
